// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-dual-ring {
  display: inline-block;
  width: 64px;
  height: 64px;
}

.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #510077;
  border-color: #510077 transparent #510077 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

.loading-spinner__overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loading-spinner__message {
  color: #510077;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  max-width: 350px;
  line-height: 1.4;
  padding: 0 1rem;
  animation: fadeIn 0.3s ease-in;
}

.loading-spinner__dots-animated::after {
  content: '.';
  display: inline-block;
  width: 1.5em;
  text-align: left;
  font-weight: bold;
  color: #510077;
  animation: dots 1.5s steps(3, end) infinite;
}

@keyframes dots {
  0% {
    content: '.';
  }
  33.33% {
    content: '..';
  }
  66.67% {
    content: '...';
  }
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/UIElements/LoadingSpinner.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".lds-dual-ring {\n  display: inline-block;\n  width: 64px;\n  height: 64px;\n}\n\n.lds-dual-ring:after {\n  content: ' ';\n  display: block;\n  width: 46px;\n  height: 46px;\n  margin: 1px;\n  border-radius: 50%;\n  border: 5px solid #510077;\n  border-color: #510077 transparent #510077 transparent;\n  animation: lds-dual-ring 1.2s linear infinite;\n}\n\n.loading-spinner__overlay {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.loading-spinner__container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.loading-spinner__message {\n  color: #510077;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: center;\n  max-width: 350px;\n  line-height: 1.4;\n  padding: 0 1rem;\n  animation: fadeIn 0.3s ease-in;\n}\n\n.loading-spinner__dots-animated::after {\n  content: '.';\n  display: inline-block;\n  width: 1.5em;\n  text-align: left;\n  font-weight: bold;\n  color: #510077;\n  animation: dots 1.5s steps(3, end) infinite;\n}\n\n@keyframes dots {\n  0% {\n    content: '.';\n  }\n  33.33% {\n    content: '..';\n  }\n  66.67% {\n    content: '...';\n  }\n}\n\n@keyframes lds-dual-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
